import { render, staticRenderFns } from "./Portada.vue?vue&type=template&id=1bd4b174&scoped=true&"
var script = {}
import style0 from "./Portada.vue?vue&type=style&index=0&id=1bd4b174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4b174",
  null
  
)

export default component.exports